import { ContactSchema } from '../../definitions/schemas';
import { Event, Properties } from '../../enums/Analytics';
import Analytics from '../../tools/Analytics';

export const trackContactSaved = (
  contact: ContactSchema,
  event: Event,
  referrer: string
) => {
  Analytics.track(event, {
    [Properties.EMAIL]: contact.email,
    [Properties.HAS_COMPANY]: !!contact.company,
    [Properties.HAS_FIRST_NAME]: !!contact.firstName,
    [Properties.HAS_LAST_NAME]: !!contact.lastName,
    [Properties.ENTERED_FROM]: referrer,
  });
};
